// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AliasRegisterStartEvent
 */
export var AliasRegisterStart = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken, isReRegistering = _a.isReRegistering, prefilledAlias = _a.prefilledAlias;
    return ({
        name: "Alias Register Start",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Register",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_re_registering: isReRegistering !== undefined && isReRegistering !== null ? isReRegistering.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            prefilled_alias: prefilledAlias !== undefined && prefilledAlias !== null ? prefilledAlias.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasRegisterGenerateTokenEvent
 */
export var AliasRegisterGenerateToken = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Alias Register GenerateToken",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Register",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasRegisterReceiveErrorEvent
 */
export var AliasRegisterReceiveError = function (_a) {
    var aliasType = _a.aliasType, errorType = _a.errorType, flowToken = _a.flowToken, isReRegistering = _a.isReRegistering;
    return ({
        name: "Alias Register ReceiveError",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Register",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_re_registering: isReRegistering !== undefined && isReRegistering !== null ? isReRegistering.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasRegisterCompleteEvent
 */
export var AliasRegisterComplete = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken, isReRegistering = _a.isReRegistering, useSuggestedAlias = _a.useSuggestedAlias;
    return ({
        name: "Alias Register Complete",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Register",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_re_registering: isReRegistering !== undefined && isReRegistering !== null ? isReRegistering.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            use_suggested_alias: useSuggestedAlias !== undefined && useSuggestedAlias !== null ? useSuggestedAlias.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasVerifyStartEvent
 */
export var AliasVerifyStart = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Alias Verify Start",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasVerifyReceiveVerificationCodeEvent
 */
export var AliasVerifyReceiveVerificationCode = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Alias Verify ReceiveVerificationCode",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasVerifyReceiveErrorEvent
 */
export var AliasVerifyReceiveError = function (_a) {
    var aliasType = _a.aliasType, errorType = _a.errorType, flowToken = _a.flowToken;
    return ({
        name: "Alias Verify ReceiveError",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasVerifyRequireHelpEvent
 */
export var AliasVerifyRequireHelp = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Alias Verify RequireHelp",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasVerifyResendEvent
 */
export var AliasVerifyResend = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Alias Verify Resend",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasVerifyEditEvent
 */
export var AliasVerifyEdit = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Alias Verify Edit",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasVerifyCallPhoneNumberEvent
 */
export var AliasVerifyCallPhoneNumber = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "Alias Verify CallPhoneNumber",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Verify",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasVerifySkipEvent
 */
export var AliasVerifySkip = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken;
    return ({
        name: "Alias Verify Skip",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AliasVerifyCompleteEvent
 */
export var AliasVerifyComplete = function (_a) {
    var aliasType = _a.aliasType, flowToken = _a.flowToken, autoVerified = _a.autoVerified, dualSimCountryIso = _a.dualSimCountryIso;
    return ({
        name: "Alias Verify Complete",
        parameters: {
            cdf_entity: "Alias",
            cdf_action: "Verify",
            alias_type: aliasType !== undefined && aliasType !== null ? aliasType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            auto_verified: autoVerified !== undefined && autoVerified !== null ? autoVerified.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dual_sim_country_iso: dualSimCountryIso !== undefined && dualSimCountryIso !== null ? dualSimCountryIso.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
